export const environment = {
  production: false,
  //urlServer: 'https://api.dev.mylocker.site/api/v1',
  //urlServerWebsocket: 'wss://api.dev.mylocker.site/websocket/website-admin/websocket',
  //urlBase: 'https://www.beta.mylocker.site',

  urlServer: 'https://api-dev.belockey.com/api/v1',
  urlServerWebsocket: 'wss://api-dev.belockey.com/websocket/website-admin/websocket',
  urlBase: 'https://www.beta.belockey.com',

  logLevel: 'debug',           // 'trace' | 'debug' | 'info' | 'warn' | 'error' | 'off'
  remoteLogUrl: '',            // deja vacío en local
  appName: 'belockey',
};
